import { render, staticRenderFns } from "./update-coupon.vue?vue&type=template&id=922a6810&scoped=true&"
import script from "./update-coupon.vue?vue&type=script&lang=js&"
export * from "./update-coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922a6810",
  null
  
)

export default component.exports